<template>
  <error v-if="error" :error="error" />
    <div id="profile" class="card card-body mt-4">
      <div class="row justify-content-center align-items-center">
        <div class="col-sm-auto col-4">
          <div class="avatar avatar-xl">
            <img :src="isLoading ? loadingImageUrl : profileImageSrc" alt="User Image" class="shadow-sm rounded-circle" />
          </div>
        </div>
        <div class="col-sm-auto col-8 my-auto">
          <div class="h-100">
            <h5 class="mb-1 font-weight-bolder">{{ state.user.fullname }}</h5>
            <p class="mb-0 font-weight-bold text-sm">{{ $t(`common.${state.user.roleName}`) }}</p>
          </div>
        </div>
        <div class="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">
        </div>
      </div>
    </div>
    <div id="basic-info" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('user.Basic_info') }}</h5>
        <p class="mb-0 text-sm">{{ $t('user.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('user.Username') }}</label>
              <input v-model="state.userName" type="text" class="form-control form-control-default" disabled>              
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('user.E-mail') }} *</label>
              <input v-model="state.email" type="text" class="form-control form-control-default" :placeholder="$t('user.E-mail')" :disabled="isRestrictedRole">
              <span v-if="v$.email.$error" class="text-sm text-danger">
                    {{ v$.email.$errors[0].$message }}
                </span>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-4">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('user.Firstname') }}</label>
                <input v-model="state.firstName" type="text" class="form-control form-control-default" :placeholder="$t('user.Firstname')" :disabled="isRestrictedRole">
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('user.Middlename') }}</label>
                <input v-model="state.middleName" type="text" class="form-control form-control-default" :placeholder="$t('user.Middlename')" :disabled="isRestrictedRole">
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('user.Lastname') }} *</label>
              <input v-model="state.lastName" type="text" class="form-control form-control-default" :placeholder="$t('user.Lastname')" :disabled="isRestrictedRole">
              <span v-if="v$.lastName.$error" class="text-sm text-danger">
                    {{ v$.lastName.$errors[0].$message }}
                </span>
            </div>
          </div>
        </div>                
        <div class="row mt-4">
          <div class="col-6">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('user.Phone_number') }}</label>
                <input v-model="state.phoneNumber" type="text" class="form-control form-control-default" :placeholder="$t('user.Phone_number')" :disabled="isRestrictedRole">
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('user.Mobile_number') }}</label>
              <input v-model="state.mobileNumber" type="text" class="form-control form-control-default" :placeholder="$t('user.Mobile_number')" :disabled="isRestrictedRole">
            </div>
          </div>
        </div>        
        <div class="row mt-4">
          <div class="col-8">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('user.Address') }} *</label>
              <input v-model="state.address" type="text" class="form-control form-control-default" :placeholder="$t('user.Address')" :disabled="isRestrictedRole">
              <span v-if="v$.address.$error" class="text-sm text-danger">
                    {{ v$.address.$errors[0].$message }}
                </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('user.House_number') }} *</label>
              <input v-model="state.houseNumber" type="text" class="form-control form-control-default" :placeholder="$t('user.House_number')" :disabled="isRestrictedRole">
              <span v-if="v$.houseNumber.$error" class="text-sm text-danger">
                  {{ v$.houseNumber.$errors[0].$message }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('user.Zipcode') }} *</label>
              <input v-model="state.zipcode" type="text" class="form-control form-control-default" placeholder="$t('user.Zipcode')" :disabled="isRestrictedRole">
              <span v-if="v$.zipcode.$error" class="text-sm text-danger">
                    {{ v$.zipcode.$errors[0].$message }}
                </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('user.City') }} *</label>
                <input v-model="state.city" type="text" class="form-control form-control-default" :placeholder="$t('user.City')" :disabled="isRestrictedRole">
                <span v-if="v$.city.$error" class="text-sm text-danger">
                    {{ v$.city.$errors[0].$message }}
                </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('user.Country') }} *</label>
              <input v-model="state.country" type="text" class="form-control form-control-default" :placeholder="$t('user.Country')" :disabled="isRestrictedRole">
              <span v-if="v$.country.$error" class="text-sm text-danger">
                {{ v$.country.$errors[0].$message }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mt-4" v-show="state.roleName === 'Keeper'">
          <div class="col-3">
            <div class="input-group input-group-static null">
              <label class="d-block mb-1" style="width: inherit;">{{ $t('user.ShareName') }}</label>
              <div class="d-block mt-1">
                <material-switch v-model="state.shareName" id="shareName" name="shareName" />
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="input-group input-group-static null">
              <label class="d-block mb-1" style="width: inherit;">{{ $t('user.ShareEmail') }}</label>
              <div class="d-block mt-1">
                <material-switch v-model="state.shareEmail" id="shareEmail" name="shareEmail" />
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="input-group input-group-static null">
              <label class="d-block mb-1" style="width: inherit;">{{ $t('user.ShareTelephone') }}</label>
              <div class="d-block mt-1">
                <material-switch v-model="state.shareTelephone" id="shareTelephone" name="shareTelephone" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 mt-2">
          <input type="hidden" v-model="state.userId" class="form-control">
          <input type="hidden" v-model="state.aspNetUserId" class="form-control">
          <input type="hidden" v-model="state.userName" class="form-control">          
          <input type="hidden" v-model="state.roleName" class="form-control">          
          <button v-on:click="updateBasicInfo" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update_contact_info') }}</button>                                                    
        </div>        
      </div>
    </div>
    <div id="password" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('user.Change_password') }}</h5>        
        <p class="mb-0 text-sm">{{ $t('user.Password_rule') }}</p>
        <p class="mb-0 text-sm">{{ $t('user.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-6">
            <div class="row mt-4">
              <div class="col-12">
                <div class="input-group input-group-static null">
                  <label class="">{{ $t('user.New_password') }} *</label>
                  <input :type="show.new ? 'text' : 'password'" class="password-input" v-model.trim="password" id="password" isrequired="true" @input="validateAll">
                  <span class="material-symbols-outlined toggle-icon" @click="toggle('new')">{{ !show.new ? 'visibility' : 'visibility_off' }}</span>              
                  <span v-if="password && !allValidationsOk" class="text-sm text-danger">{{ $t('user.New_password_value_is_invalid') }}</span>                  
                </div>
              </div>
            </div>
            <div class="row mt-6">
              <div class="col-12">
                <div class="input-group input-group-static null">
                  <label class="">{{ $t('user.Repeat_new_password') }} *</label>
                  <input :type="show.confirm ? 'text' : 'password'" class="password-input" v-model.trim="confirmPassword" id="confirmPassword" isrequired="true" @input="validateAll">
                  <span class="material-symbols-outlined toggle-icon" @click="toggle('confirm')">{{ !show.confirm ? 'visibility' : 'visibility_off' }}</span>              
                  <span v-if="confirmPassword && !passwordsMatch" class="text-sm text-danger">{{ $t('user.Passwords_do_not_match') }}</span>                  
                </div>
              </div>
            </div>            
          </div>
          <div class="col-6">
              <ul class="checklist">
                <li :class="{ok: validations.lengthOk}">
                  <Icon :ok="validations.lengthOk" /> {{ $t('user.Longer_than_7_characters') }}
                </li>
                <li :class="{ok: validations.hasUpper}">
                  <Icon :ok="validations.hasUpper" /> {{ $t('user.Contains_a_capital_letter') }}
                </li>
                <li :class="{ok: validations.hasLower}">
                  <Icon :ok="validations.hasLower" /> {{ $t('user.Contains_a_lowercase_letter') }}
                </li>
                <li :class="{ok: validations.hasDigit}">
                  <Icon :ok="validations.hasDigit" /> {{ $t('user.Contains_a_number') }}
                </li>
                <li :class="{ok: validations.hasSpecial}">
                  <Icon :ok="validations.hasSpecial" /> {{ $t('user.Contains_a_special character') }}
                </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-sm-12 mt-6">                                
          <button v-on:click="updatePassword" class="btn btn-sm bg-gradient-success mr-2 float-end" :disabled="!canSubmit">{{ $t('user.Update_password') }}</button>                                                    
        </div>        
      </div>
    </div>    
    <div id="sessions" class="card mt-4">
      <div class="card-header pb-3">
        <h5>{{ $t('user.Sessions') }}</h5>
        <p class="text-sm">
          {{ $t('user.This_is_a_list_of_devices_that_have_logged_into_your_account') }}          
        </p>
      </div>
      <div class="card-body pt-0" v-for="(userAction, index) in userActions" v-bind:key="userAction.id">
        <div class="d-flex align-items-center">
          <div class="text-center w-5">
            <i class="fas fa-desktop text-lg opacity-6" v-if="userAction.deviceType === 'Desktop'"></i>
            <i class="fas fa-mobile text-lg opacity-6" v-else></i>
          </div>
          <div class="my-auto ms-3">
            <div class="h-100">
              <p class="text-xs mb-1">{{ userAction.userAgent }} <br> {{ userAction.userHostIp }}</p>
              <material-badge v-if="index === 0" color="success" size="sm" class="my-auto ms-auto me-3">{{ $t('user.Active') }}</material-badge>
            </div>
          </div>          
          <p class="mb-0 text-xs ms-auto me-3" style="text-align: right;">{{ formatDate(userAction.dateTimeStamp) }}</p>
        </div>
      </div>
    </div>
    <div id="media" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('user.Image') }}</h5>   
        <p class="text-sm">
          {{ $t('user.Profile_image') }}
        </p>     
      </div>
      <div class="card-body pt-0">
        <div class="row mt-2">
          <div class="col-12">
            <div id="profileImg" class="form-control border dropzone"></div>
          </div>   
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <button v-on:click="uploadImage" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('user.Upload_image') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>
  </template>
  
  <script>
  import MaterialBadge from "@/components/MaterialBadge.vue";
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import Dropzone from "dropzone";
  import axios from 'axios'
  import useValidate from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'
  import Error from '../../../components/GlobalAlert.vue'
  import loadingImageUrl from "@/assets/img/LoadingImage.gif";
  import { useI18n } from 'vue-i18n'
  import emitter from '@/eventBus';
  import { h } from 'vue';
  import { mapMutations } from 'vuex';

  const Icon = {
    name: 'Icon',
    props: { ok: { type: Boolean, default: false } },
    render() {
      if (this.ok) {
        return h('svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            width: '16',
            height: '16',
            viewBox: '0 0 24 24',
            'aria-hidden': 'true'
          },
          [
            h('path', {
              fill: '#1aa34a',
              d: 'M9 16.2l-3.5-3.5-1.4 1.4L9 19 20 8l-1.4-1.4z'
            })
          ]
        );
      } else {
        return h('svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            width: '16',
            height: '16',
            viewBox: '0 0 24 24',
            'aria-hidden': 'true'
          },
          [
            h('path', {
              fill: '#d33',
              d: 'M12 10.6l4.9-4.9 1.4 1.4L13.4 12l4.9 4.9-1.4 1.4L12 13.4l-4.9 4.9-1.4-1.4L10.6 12 5.7 7.1 7.1 5.7 12 10.6z'
            })
          ]
        );
      }
    }
  };

  export default {
    name: "ProfileDetailsPage",
    setup() {
        const { t } = useI18n()

        const state = reactive ({            
            user: [],
            userActions: [],
            userId: '',
            aspNetUserId: '',
            firstName: '',
            middleName: '',
            lastName: '',
            email: '',
            userName: '',
            phoneNumber: '',
            mobileNumber: '',
            address: '',
            city: '',
            zipcode: '',
            country: '',
            roleName: '',  
            houseNumber: '',          
            fullName: '',
            shareTelephone: false,            
            shareEmail: false,
            shareName: false,
        })

        const isRestrictedRole = computed(() => 
          state.roleName === "Keeper" || state.roleName === "Inspector"
        );
        
        const rules = computed(() => {
            return {              
              lastName: { required: helpers.withMessage(t('common.Required'), required) },
              email: { required: helpers.withMessage(t('common.Required'), required) },
              address: { required: helpers.withMessage(t('common.Required'), required) },
              houseNumber: { required: helpers.withMessage(t('common.Required'), required) },
              city: { required: helpers.withMessage(t('common.Required'), required) },
              zipcode: { required: helpers.withMessage(t('common.Required'), required) },
              country: { required: helpers.withMessage(t('common.Required'), required) }
            }
        })  
                
        const v$ = useValidate(rules, state)

        return {
            state,
            isRestrictedRole,
            v$
        }
    },   
    computed: {
      allValidationsOk() {
        const v = this.validations;
        return v.lengthOk && v.hasUpper && v.hasLower && v.hasDigit && v.hasSpecial;
      },
      canSubmit() {      
        const v = this.validations;
        return (
          v.lengthOk &&
          v.hasUpper &&
          v.hasLower &&
          v.hasDigit &&
          v.hasSpecial &&
          this.passwordsMatch
        );
      },
      passwordsMatch() {      
        return (
          this.password &&
          this.confirmPassword &&
          this.password === this.confirmPassword
        );
      },
    }, 
    components: {
      Error,
      MaterialBadge,
      MaterialSwitch,
      Icon
    },
    data() {
      return {
        user: [],
        userActions: [],
        gets: [],
        error: '',
        //img,  
        password: '',
        confirmPassword: '',        
        dropzoneInstance: null, 
        fileAdded: false,
        selectedFile: null, 
        profileImageSrc: null, 
        isLoading: true,
        loadingImageUrl,
        validations: {
          lengthOk: false,
          hasUpper: false,
          hasLower: false,
          hasDigit: false,
          hasSpecial: false
        },
        show: {
          current: false,
          new: false,
          confirm: false
        },
      };
    },
    async mounted() {  
      this.userId = this.$route.params.userId;
      this.validateAll();
      this.initializeDropzone();
      await this.fetchProfileData();
      await this.fetchUserImage();
    },
    methods: {
      ...mapMutations(['toggleEveryDisplay', 'toggleHideConfig']),

      toggle(which) {
        if (which in this.show) {
          this.show[which] = !this.show[which];
        }
      },

      validateAll() {
        const pwd = this.password || '';
        this.validations.lengthOk = pwd.length >= 8;
        this.validations.hasUpper = /[A-ZÀ-ÖØ-Þ]/.test(pwd);
        this.validations.hasLower = /[a-zà-öø-ÿ]/.test(pwd);
        this.validations.hasDigit = /[0-9]/.test(pwd);
        this.validations.hasSpecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(pwd);
      },

      formatDate(dateTimeStamp) {
          return new Date(dateTimeStamp).toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
      }, 
      initializeDropzone() {
        const vm = this; // Store reference to the Vue component instance

        this.dropzoneInstance = new Dropzone("#profileImg", {
          url: "/file-upload", // Not used, but Dropzone requires it
          autoProcessQueue: false,
          maxFiles: 1,
          acceptedFiles: 'image/*',
          dictDefaultMessage: "Sleep bestanden hierheen om te uploaden",
          dictRemoveFile: "Verwijderen"
        });

        this.dropzoneInstance.on("addedfile", function(file) {
          vm.fileAdded = true;
          vm.selectedFile = file;
          console.log("File added:", file);
        });
      },      
      async fetchProfileData() {
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get('User/detail');
            this.gets = response.data;

            if (this.gets.success) {
                this.state.user = this.gets.data.user;
                this.userActions = this.gets.data.userActions;

                this.state.firstName = this.state.user.firstName;
                this.state.middleName = this.state.user.middleName;
                this.state.lastName = this.state.user.lastName;
                this.state.userName = this.state.user.userName;
                this.state.email = this.state.user.email;
                this.state.phoneNumber = this.state.user.phoneNumber;
                this.state.mobileNumber = this.state.user.mobileNumber;
                this.state.houseNumber = this.state.user.houseNumber;
                this.state.address = this.state.user.address;
                this.state.city = this.state.user.city;
                this.state.zipcode = this.state.user.zipcode;
                this.state.userId = this.state.user.id;
                this.state.aspNetUserId = this.state.user.aspNetUserId;
                this.state.fullName = this.state.user.fullName;
                this.state.country = this.state.user.country;
                this.state.roleName = this.state.user.roleName;
                this.state.shareTelephone = this.state.user.shareTelephone;                
                this.state.shareEmail = this.state.user.shareEmail;
                this.state.shareName = this.state.user.shareName;
            } else {
                this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {                    
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }        
      },
      async fetchUserImage() {
        try {
            this.$store.commit('setShowLoading', true);
            this.isLoading = true;
            const response = await axios.get(`user/getprofileimage/`, {
              params: { aspNetUserId: this.state.aspNetUserId },
              responseType: 'blob', // Important to set the response type as 'blob'
            });            
            const imageBlob = response.data;
            this.profileImageSrc = URL.createObjectURL(imageBlob);
        } catch (error) {
            console.error('Error fetching user image:', error);            
        } finally {
            this.isLoading = false; // Set loading state to false after fetching
            this.$store.commit('setShowLoading', false);
        }
      },
      async uploadImage() {
        this.$store.commit('setShowLoading', true);
        const files = this.dropzoneInstance.getQueuedFiles();

        if (files.length > 0) {
          const file = files[0]; // Since maxFiles is set to 1, we take the first file
          const formData = new FormData();
          formData.append('image', file);
          formData.append('userId', this.state.userId);

          try {
            const response = await axios.put('user/updateimage', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
            console.log('Image uploaded successfully:', response.data);
            this.dropzoneInstance.removeAllFiles(); // Clear Dropzone after successful upload
            this.fileAdded = false; // Reset the file added flag

            this.$showSuccess('errors.Success_image_updated_successfully');
            emitter.emit('profile:image-updated');

            this.$router.push('/profile').then(() => {
              this.fetchUserImage(); // Trigger data refresh or any required action
            });
          } catch(e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
        } else {
          this.$showError('errors.No_image_selected_for_upload');          
        }
        this.$store.commit('setShowLoading', false);
      },
      async updateBasicInfo() {   
          try {
              this.$store.commit('setShowLoading', true);

              this.v$.$validate();                
              console.log(this.v$.$error);

              if(!this.v$.$error) {
                  const response = await axios.put('user/update', {
                    "id": this.state.userId,
                    "aspNetUserId": this.state.aspNetUserId,
                    "firstName": this.state.firstName,
                    "middleName": this.state.middleName,
                    "lastName": this.state.lastName,
                    "email": this.state.email,            
                    "phoneNumber": this.state.phoneNumber,
                    "mobileNumber": this.state.mobileNumber,
                    "address": this.state.address,
                    "city": this.state.city,
                    "zipcode": this.state.zipcode,
                    "country": this.state.country,
                    "roleName": this.state.roleName,
                    "userName": this.state.userName,
                    "houseNumber": this.state.houseNumber,
                    "shareTelephone": this.state.shareTelephone,
                    "shareAddress": true,
                    "shareEmail": this.state.shareEmail,
                    "shareName": this.state.shareName
                  });
                  this.gets = response.data;

                  if (this.gets.success) {

                    this.$showSuccess('errors.Success_basicinfo_updated_successfully');

                    this.$router.push('/profile').then(() => {
                      this.fetchProfileData(); // Trigger data refresh or any required action
                    });
                  } else {
                      this.$showError('errors.Contact_system_admin');
                  }
              }                
          } catch(e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          } finally { 
            this.$store.commit('setShowLoading', false);
          }
        },      
      async updatePassword() {
        if (!this.canSubmit) return;

        try {
            this.$store.commit('setShowLoading', true);

            const response = await axios.put('user/updatepassword', {
              aspNetUserId: this.state.aspNetUserId,
              newPassword: this.password
            });
            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_User_password_updated_successfully');

              // clear form
              this.password = '';
              this.confirmPassword = '';
              this.validateAll();

              this.$router.push('/profile').then(() => {
                this.fetchProfileData(); // Trigger data refresh or any required action
              });

            } else {
                this.error = 'Oops!! Error contact system admin.';
            }
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
      }
    },     
  };
</script>
<style scoped>
    .password-input-wrapper {
      position: relative;
      width: 100%;
    }

    .password-input {
      width: 100%;
      padding-right: 2.5rem; /* Reserve space for the icon */
      border: none;
      border-bottom: 1px solid #ccc;
      outline: none;
    }

    .password-input:focus {
      border-bottom-color: green; /* or your primary color */
    }

    .toggle-icon {
      position: absolute;
      top: 50%;
      right: 0.5rem;
      transform: translateY(-50%);
      cursor: pointer;
    }
</style>
